import React from "react";
import resetPassword from "assets/Login/resetPassword.png";
import Button from "components/molecules/Button";
import Form from "components/molecules/Form/Form";
import { useForm } from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import OtpInput from "components/molecules/Otp";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import {useNavigate } from "react-router-dom";
const EmailOtp = () => {
  const [form] = useForm();
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    console.log(e);
    navigate("/change-password");
  };
  return (
    <OnBoardingLayout img={resetPassword}>
      <Heading heading="Verify OTP!" para="We’ve send you the verification code on" paraColoured="sipraokasha@gmail.com!" />
      <Form form={form} onSubmit={handleSubmit}>
        <OtpInput
          numInputs={4}
          setOtpValue={(e) => console.log(e.join(""))}
          inputBg={"transparent"}
          onChange={(e) => console.log(e)}
        />
        <Button lg>Confirm OTP</Button>
      </Form>
    </OnBoardingLayout>
  );
};

export default EmailOtp;
